import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { RootState } from '../../stores/store';
import { getSorting } from '../../stores/tables/selectors';
import { TableSorting } from '../../stores/tables/state';

class TableColumn extends React.Component<React.HTMLAttributes<HTMLTableHeaderCellElement>> {
    public render() {
        const {children, ...rest} = this.props;
        return (
            <th {...rest}>
                {children}
            </th>
        );
    }
}

export default TableColumn;